module.exports = __webpack_public_path__ + "img/eye-white.56642a4a.svg";